import React from 'react';
import { CirclePlay, Clock, Webhook, Zap } from 'lucide-react';
import { Handle, NodeProps, Position } from 'reactflow';
import type { TriggerKind } from '../triggerWorkflowTypes';
import type { WorkflowRegistryFields } from '../Sidebar/sidebarPalette';
import './TriggerNode.css';

export type TriggerNodeData = {
  label: string;
  triggerKind: TriggerKind;
  preview: string;
} & WorkflowRegistryFields;

const KIND_ICONS: Record<TriggerKind, React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>> =
  {
    manual: CirclePlay,
    webhook: Webhook,
    scheduled: Clock,
    event: Zap,
  };

function TriggerNode({ data, selected }: NodeProps<TriggerNodeData>) {
  const KindIcon = KIND_ICONS[data.triggerKind];
  return (
    <div
      className={`trigger-node${selected ? ' trigger-node--selected' : ''}`}
      role="group"
      aria-label={data.label}
    >
      <div className="trigger-node__header">
        <span className="trigger-node__dot" aria-hidden />
        <KindIcon className="trigger-node__icon" strokeWidth={2} size={14} aria-hidden />
        <span className="trigger-node__title">{data.label}</span>
      </div>
      <div className="trigger-node__body">{data.preview}</div>
      <Handle
        type="source"
        position={Position.Right}
        id="out"
        className="trigger-node__handle"
        isConnectable
      />
    </div>
  );
}

export default TriggerNode;
